// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-page-header-button-group .fi-page-header-button {
  margin-left: 7px;
  height: 34px;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-page-header-button-group/fi-page-header-button-group.component.scss"],"names":[],"mappings":"AACI;EACI,gBAAA;EACA,YAAA;AAAR","sourcesContent":[".fi-page-header-button-group {\r\n    .fi-page-header-button {\r\n        margin-left: 7px;\r\n        height: 34px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
